import { makeAutoObservable } from 'mobx';

import { FilterStore } from '../../shared/util-stores';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import {
  PreRegisteredFilterValues,
  PreRegisteredFilters,
  PreRegisteredSortField,
} from '../interfaces/PreRegisteredFilters';
import { PreRegisteredInfo } from '../interfaces/PreRegisteredRowInfo';
import { requiredAttentionService } from '../services/requiredAttentionService';

class PreRegisteredStore {
  preRegisteredList: PreRegisteredInfo[] = [];
  filterMethods: FilterStore<PreRegisteredFilterValues, PreRegisteredSortField>;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<
      PreRegisteredFilterValues,
      PreRegisteredSortField
    >(this.handleGetPreRegistered);
  }

  setDefaultValues() {
    this.preRegisteredList = [];
    this.filterMethods.setDefaultValues();
  }

  private async handleGetPreRegistered({ requestedPage, sort }: PreRegisteredFilters) {
    const response = await requiredAttentionService.getPreRegistered({
      requestedPage,
      sort,
    });

    this.setPreRegisteredList(response.content);

    return response;
  }

  async getPreRegisteredList() {
    return this.filterMethods.getData();
  }

  private setPreRegisteredList(preRegisteredList: PreRegisteredInfo[]) {
    this.preRegisteredList = preRegisteredList;
  }
}

const preRegisteredStore = new PreRegisteredStore();
resetAllStore.addResetMethod(preRegisteredStore.setDefaultValues);

export { preRegisteredStore, PreRegisteredStore };
